<template>
	<o-sticker
		class="unlock-order-module-agency-sticker"
		:selected="selected">
		<template #actions>
			<o-icon
				v-tooltip="`Sélectionner`"
				:class="{ 'unlock-order-module-agency-sticker__action--none': setup.agency.isActive || setup.agency.pluginRequest }"
				ripple="info"
				font-icon="icon-interface-validation-check"
				@click="$emit('select', agency)"/>
			<o-icon
				v-tooltip="`Débloquer`"
				:class="{ 'unlock-order-module-agency-sticker__action--none': setup.agency.isActive || setup.agency.pluginRequest }"
				ripple="info"
				font-icon="icon-interface-unlock"
				@click="$emit('unlock', agency)"/>
		</template>
		<div class="row row--grid-xs">
			<div class="col">
				<div class="unlock-order-module-agency-sticker__header">
					<shared-logo-company
						class="unlock-order-module-agency-sticker__logo"
						:company="setup.agency"/>
					<p class="unlock-order-module-agency-sticker__title">
						<strong>{{ setup.agency.name }}</strong> <br>
						{{ setup.agency.contactDetailCity }}
					</p>
				</div>
			</div>
			<div class="col unlock-order-module-agency-sticker__col">
				<o-icon-section>
					<small
						class="unlock-order-module-agency-sticker__small">
						Commandes effectuées
					</small>
					<div
						v-if="!setup.agency.isActive"
						class="unlock-order-module-agency-sticker__indicator">
						<span
							v-for="bar in 5"
							:key="bar"
							class="unlock-order-module-agency-sticker__bar"
							:class="{
								'unlock-order-module-agency-sticker__bar--success' : (bar <= agency.agencyOrdersCount),
							}"/>
						{{ agency.agencyOrdersCount }}/5
					</div>
					<strong v-else>
						{{ agency.agencyOrdersCount }}
					</strong>
				</o-icon-section>
			</div>

			<div class="col unlock-order-module-agency-sticker__col">
				<o-label
					:color="setup.agency.agencyLockedStatus.color"
					outline>
					{{ setup.agency.agencyLockedStatus.label }}
				</o-label>
			</div>
		</div>
	</o-sticker>
</template>

<script setup lang="ts">
import UnlockModuleOrderAgencyCardSetupService from '@/setup/unlock-module/order/UnlockModuleOrderAgencyCardSetupService';
type Emits = { (e: 'unlock' | 'select', val: ICompanyWithOrderPluginModel): void }
defineEmits<Emits>();
const props = defineProps(UnlockModuleOrderAgencyCardSetupService.props);
const setup = new UnlockModuleOrderAgencyCardSetupService(props);
</script>


<style lang="less">
@import '@/styles/variables';
@import '@/styles/mixins';

  .unlock-order-module-agency-sticker {

    @media @phone {
      flex-direction: row;
    }
    // opacity: 0;
    &__col {
      display: flex;
      align-items: center;
    }
    .orion-sticker__actions{
      display: flex;
      align-items: center;
      justify-content: center;
      .orion-icon{
        display: block;
      }
      .orion-label{
        position: absolute;
        display: block;
      }
    }

    &__header{
      // position: relative;
      display: flex;
      align-items: center;
      gap: 1rem;
    }

    &__action{
      padding: 0.6rem;
      background: rgb(var(--rgb-grey-light), 0.3);
      border-radius: 50%;
      position: absolute;
      right: 0;
      font-size: 1.3rem;

      &--default{
        background: rgb(var(--rgb-info), 0.1);
        color: var(--info);
      }

      &--success{
        background: rgb(var(--rgb-success), 0.1);
        color: var(--success);
      }
    }

    &__logo{
      width: 2.5rem;
      height: 2.5rem;
      border-radius: 0.3rem;
      // background: white;
    }

    &__title {
      font-size: 0.9rem;
      margin: unset;
      max-width: 50%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__small{
      font-size: 0.9rem;
      display: block;

      &--empty {
        color: var(--danger);
        font-weight: 600;
      }
    }

    .orion-icon-section{
      .orion-icon{
        margin-left: unset;
        margin-right: 0.9rem;
      }
    }

    &__indicator{
      display: flex;
      gap: 0.4rem;
      align-items: center;
    }

    &__bar{
      height: 0.6rem;
      width: 0.6rem;
      border-radius: 50%;
      background: var(--grey-light);

      &--success {
        background: var(--success);
      }
      &--warning {
        background: var(--warning);
      }
      &--empty {
        background: var(--grey-light);
      }
    }
    &__label{
      padding: 0.9rem 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__action {
      &--none {
        pointer-events: none;
        opacity: 0;
      }
    }
  }
</style>
